<!--
  * @Descripttion: 我的控销页面
  * @version: V1.6.4
  * @Author: zhangwenxia
  * @Date: 2021-07-19
  -->
<template>
  <div>
    <iMineTemplate :page-title="pageTitle" :actived-parent-key="activedParentKey" :actived-key="activedKey">
      <template #rightContent>
        <!-- 控销列表-->
        <a-spin :spinning="loading">
          <div class="my-control-pin-box">
            <div class="flex  align-items-center flex-column-align-lr">
              <div class="head-title flex align-items-center">
                <h4>我的控销</h4>
                <p>
                  <van-icon
                    style="color: red;"
                    :name="require('@/assets/mine/introduce.png')"
                    size="13px"
                  />
                  <span @click="dialogVisible = true">药约約品种控销规则介绍</span>
                </p>
              </div>
              <!--搜索-->
              <div>
                <el-input
                  v-model="searchParams.keywords"
                  v-keyup="{ delay: 500, fn: onLoad }"
                  class="custom-input"
                  size="small"
                  placeholder="请输入商品名称"
                >
                  <div slot="prefix" class="search-icon">
                    <van-icon :name="require('@/assets/mine/search.png')" size="14px" />
                  </div>
                </el-input>
              </div>
            </div>
            <!-- 分割条-->
            <div class="line" />
            <!-- 控销列表信息-->
            <div class="detail flex  align-items-center flex-column-align-lr">
              <div class="flex align-items-center">
                <p>控销品种：{{ totalCount }}</p>
                <p class="sort flex align-items-center">
                  <span>释放时间</span>
                  <i
                    class="el-icon-sort-down ml05"
                    :class="{ active: searchParams.sortType === 1 }"
                    @click="changeSort()"
                  />
                  <i
                    style="margin-left: -8px;"
                    class="el-icon-sort-up"
                    :class="{ active: searchParams.sortType === 2 }"
                    @click="changeSort()"
                  />
                </p>
              </div>
              <div>
                <el-button
                  class="custom-btn c0F6EEA"
                  size="small"
                  type="text"
                  icon="el-icon-plus"
                  @click="addControlPinKind"
                >添加更多控销品种</el-button>
              </div>
            </div>
            <div class="mt10">
              <div class="goods-list-box flex flex-row">
                <div v-for="(item, index) in dataList" :key="index" class="goods-item">
                  <div class="pd-box">
                    <div class="goods-img-box" @click.stop="handleDetail(item)">
                      <div class="goods-img"><img
                        class="goods-pic"
                        :src="_getPic(item.img || item.Logo, true)"
                        alt=""
                      ></div>
                      <template v-if="!item.MarketControlInfo.IsOverControlTime">
                        <div class="goods-class hint">
                          <p class="ellips-text">
                            距控销释放还剩：{{ item.MarketControlInfo.WillFreeControlDays }}天</p>
                        </div>
                      </template>
                      <template v-if="item.MarketControlInfo.IsOverControlTime">
                        <div class="goods-class warning">
                          <p class="ellips-text">
                            已过释放期，{{ item.MarketControlInfo.WillLoseControlDays }}天后将失去控销权
                          </p>
                        </div>
                      </template>
                      <template v-if="item.ActivityType">
                        <div class="goods-class active">
                          <img v-if="item.ActivityType && item.ActivityType ===8 " class="img_ms" src="@/assets/goods/tag_ms.png">
                          <img v-if="item.ActivityType && item.ActivityType ===5 " class="img_tj" src="@/assets/goods/tag_tj.png">
                          <img v-if="item.ActivityType && item.ActivityType ===9 " class="img_tj" src="@/assets/goods/tag_xq.png">
                          <img v-if="item.ActivityType && item.ActivityType ===7 " class="img_m img_mf " src="@/assets/goods/tag_mf.png">
                          <img v-if="item.ActivityType && item.ActivityType=== 6 " class="img_m" src="@/assets/goods/tag_mj.png">
                          <img v-if="item.ActivityType && item.ActivityType ===3 " class="img_m" src="@/assets/goods/tag_mz.png">
                          <img v-if="item.ActivityType && item.ActivityType ===4 " class="img_m" src="@/assets/goods/tag_hg.png">
                          <div v-if="item.Condition && item.Condition" class="rule_show" :class="{'hg_rule':item.ActivityType && item.ActivityType ===4,'mf_rule': (item.ActivityType && item.ActivityType ===7) || (item.ActivityType && item.ActivityType === 6)}">
                            {{ item.Condition }}
                          </div>
                        </div></template>
                    </div>
                    <div class="goods-info mt10">
                      <div class="tag-box">
                        <!-- 医保标签标签 -->
                        <div
                          v-for="properties in item.CommodityListProperties"
                          v-if="properties.AttributeName == '医保类型'"
                          :key="properties.Id"
                          style="margin-right: 4px; font-size: 0;"
                        >
                          <img
                            v-if="properties.Value == 1"
                            src="@/assets/goods/class_a.png"
                            width="28px"
                            height="16px"
                          >
                          <img
                            v-if="properties.Value == 2"
                            src="@/assets/goods/class_b.png"
                            width="28px"
                            height="16px"
                          >
                          <img
                            v-if="properties.Value == 3"
                            src="@/assets/goods/yibao.png"
                            width="28px"
                            height="16px"
                          >
                        </div>
                        <!-- 商品标签 -->

                        <img
                          v-if="item.GoodsTags && item.GoodsTags.length"
                          :src="item.GoodsTags[0].Img"
                          style="margin-right: 4px; width: 32px; height: 16px;"
                        >

                        <div class="goods-name ellips-text" @click.stop="handleDetail(item)">
                          {{ item.OperationName || item.SkuName }}
                        </div>
                      </div>
                      <div class="goods-msg-item ellips-text" @click.stop="handleDetail(item)">
                        规格：{{ item.Specifications }}/{{ item.Unit }}</div>
                      <div
                        v-for="(time, index) in item.CommodityListProperties"
                        v-if="time.AttributeName == '效期优于' && time.AttributeName != '医保类型'"
                        :key="index"
                        class="goods-msg-item ellips-text"
                        @click.stop="handleDetail(item)"
                      >
                        效期：效期优于{{ time.value }}
                      </div>
                      <div class="goods-price" @click.stop="handleDetail(item)">
                        <span class="money">¥
                          {{ item.PriceActivity ? item.PriceActivity : item.PriceLimit }}</span>
                      </div>
                      <div class="goods-disc" @click.stop="handleDetail(item)">
                        <span>
                          最低零售价 ¥{{ Number(item.RetailPrice).toFixed(2) }} | 毛利率{{
                            _showProductProfit(item.RetailPrice, _getProductPrice(item.PriceActivity, item.PriceLimit)) + '%'
                          }}
                        </span>
                      </div>
                      <div class="goods-bottom flex align-items-center">
                        <div style="flex: 1;">
                          <van-stepper
                            v-model="item.cartNum"
                            :min="item.OutPurchaseAgreementDto.PurchaseNumber"
                            :disable-plus="item.cartNum >= item.Stock || (item.LimitPerOrder && item.cartNum >= item.LimitPerOrder)"
                            :step="item.OutPurchaseAgreementDto.StepLengthNumber"
                            integer
                          />
                        </div>
                        <div>
                          <a-button
                            type="primary"
                            :class="{
                              'join-btn': item.MarketControlInfo && item.MarketControlInfo.IsOverControlTime,
                              'join-btn-control': item.MarketControlInfo && !item.MarketControlInfo.IsOverControlTime
                            }"
                            @click="addCartVerifyHasActiveGoods(item)"
                          >
                            {{ item.MarketControlInfo && item.MarketControlInfo.IsOverControlTime ? '优先续控' : '续控' }}
                          </a-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 控销列表END-->
            <!--分页条-->
            <div :class="totalCount > 0 ? 'search-pagination' : 'hide-pagination'">
              <iPagination
                v-if="dataList && dataList.length"
                :current-page.sync="pageIndex"
                :limit.sync="pageSize"
                :total-count="totalCount"
                small
                @turn="onLoad"
              />
              <EmptyControl
                v-if="dataList && !dataList.length"
                style="margin: 20px 0; padding: 100px 0;"
                type="goods"
                text="对不起，您还未添加控销商品"
              />
            </div>
          </div>
        </a-spin>
      </template>
    </iMineTemplate>
    <!--规则介绍 -->
    <el-dialog class="custom-dialog" :visible.sync="dialogVisible" :show-close="false" width="700px">
      <div class="dialog-content">
        <div class="dialog-head">
          <p>控销规则介绍</p>
          <i class="el-icon-circle-close" @click="dialogVisible = false" />
        </div>
        <div class="dialog-body">
          <p>1、药约約品种控销，按GPS定位进行区域控制；</p>
          <p>2、按照购买即控销的原则，先到先得，同区域其他客户对我控销的品种不可见，不可购买；</p>
          <p>3、一个控销品的周期为60天，60天内无复购将会被释放，同区域其他客户将会有机会获得控销权；</p>
          <p>4、续控的规则：在周期内及时复购，即可继续控销；</p>
          <p>5、续控或添加新的控销品后，请及时到购物车结算，结算付款后才会完成控销权的确认。</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="custom-btn1" size="mini" type="primary" @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!--规则介绍END -->
    <!-- 控销有活动商品弹框 -->
    <el-dialog
      class="custom-dialog"
      :visible.sync="dialogHasActiveVisible"
      :show-close="false"
      width="700px"
      @close="toCarActiveItem = null"
    >
      <div class="dialog-content">
        <div class="dialog-head">
          <p>添加控销产品</p>
          <i class="el-icon-circle-close" @click="dialogHasActiveVisible = false" />
        </div>
        <div class="dialog-body">
          <p style="margin-bottom: 0; text-align: center;">该商品正在参与优惠活动，您可以选择原价购买或者购买活动商品，<br>
            均可以完成续控
          </p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="custom-btn-origin" size="mini" type="primary" @click="toBuyOriginPrice">原价购买
        </el-button>
        <el-button class="custom-btn1" size="mini" type="primary" @click="toLookMoreActiveGoods">查看活动
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import iPagination from '@/components/iPagination'
import { LinkTypeCode } from '@/dictionary/base'
import { BaseMixin } from '@/mixins/BaseMixin'

export default {
  name: 'MyControlPin',
  components: { iPagination },
  mixins: [BaseMixin],
  data() {
    return {
      toCarActiveItem: null, // 存储已原价购买时当前选择的商品
      dialogHasActiveVisible: false, // 添加控销有活动商品提示
      dialogVisible: false,
      pageTitle: ['我的收藏', '我的控销'],
      activedParentKey: 3,
      activedKey: 33,
      dataList: [],
      searchParams: {
        keywords: '',
        sortType: 0
      },
      totalCount: 0,
      pageSize: 8,
      pageIndex: 1,
      loading: false
    }
  },
  created() {
    this.pageIndex = 1
    this.onLoad()
  },
  methods: {
    /**
			 * 获取控销列表数据
			 */
    onLoad(index) {
      this.loading = true
      this.getAction('/api_customers/Customer/GetControlGoodsList', {
        keywords: this.searchParams.keywords,
        sortType: this.searchParams.sortType,
        pageNum: this.pageIndex,
        pageSize: this.pageSize
      }).then(res => {
        if (res.IsSuccess) {
          // 给每一条数据都追加一个临时变量，用于保存当前选中数量
          this.dataList = res.Data.map(item => {
            return {
              ...item,
              cartNum: item.OutPurchaseAgreementDto.PurchaseNumber
            }
          })
          this.totalCount = res.Count
          this.loading = false
        } else {
          this.loading = false
          this.$toast({ position: 'bottom', message: res.Msg })
        }
      })
      // .finally(() => {
      // 	this.$hys.clearLoading();
      // });
    },
    /**
			 * 切换排序状态
			 */
    changeSort() {
      if (this.searchParams.sortType === 0) {
        this.searchParams.sortType = 1
      } else {
        this.searchParams.sortType === 1 ? (this.searchParams.sortType = 2) : (this.searchParams.sortType = 1)
      }
      this.pageIndex = 1
      this.onLoad()
    },
    /**
			 * 跳转详情
			 */
    handleDetail(item) {
      this._jump(
        this.Enum_LinkTypeCode.ProductDetails, {
          id: item.Id,
          detailType: item.SourceGoodsSkuId ? 'specialOffer' : '',
          configType: item.GoodsType !== 3 ? '' : '', // 暂留
          ruleText: item.RuleText || ''
        },
        '_blank'
      )
    },
    /**
			 * 添加控销品种
			 */
    addControlPinKind(item) {
      this.$router.push({ name: LinkTypeCode.AddControlPinKind })
    },
    /**
			 * 控销商品有活动商品时，查看跳转
			 */
    async toLookMoreActiveGoods() {
      const { Id } = this.toCarActiveItem
      const res = await this.getAction('/api_customers/Customer/GetControlActiveGoodsIds', { Id })
      if (res.IsSuccess) {
        // 是否有商城活动商品
        const storeActiveList = res.Data.filter(item => (!item.IsSpecial || !item.SpecialAreaId))
        // 是否有专区活动商品
        const specialList = res.Data.filter(item => item.IsSpecial)
        const storeActiveGoodsIds = storeActiveList.map(item => item.ActiveGoodsIds).join(',') || ''
        // 只有专区时跳转第一个商品对应专区
        if (specialList.length && !storeActiveList.length) {
          const toId = specialList[0].SpecialAreaId || ''
          const toUrl = this.$router.resolve({ path: 'SpecialOffer', query: { id: toId }})
          window.open(`${toUrl.href}`, '_blank')
          return
        }
        const toUrl = this.$router.resolve({
          name: LinkTypeCode.SearchPage,
          params: { ids: storeActiveGoodsIds }
        })
        // 跳转商品列表
        window.open(`${toUrl.href}?ids=${toUrl.location.params.ids || ''}`, '_blank')
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    /** *
			 * 加购前判断当前商品是否有关联活动
			 * */
    addCartVerifyHasActiveGoods(item) {
      const { ShoppingCartCount, hasActivatingGoods } = item
      if (hasActivatingGoods && !ShoppingCartCount) {
        this.toCarActiveItem = item
        // 弹窗提示
        this.dialogHasActiveVisible = true
      } else {
        this.addCart(item)
      }
    },
    /**
			 * 控销原价购买
			 */
    toBuyOriginPrice() {
      const { toCarActiveItem } = this
      this.addCart(toCarActiveItem)
      this.dialogHasActiveVisible = false
    },
    /*
			 * 加入购物车
			 * @param {object} e: 商品对象
			 */
    async addCart(e) {
      // 判断是否超出限购
      if (!!e.LimitPerOrder && e.cartNum > e.LimitPerOrder) {
        this.$toast({
          position: 'bottom',
          message: '单笔订单限购（' + e.LimitPerOrder + '）' + e.Unit
        })
        return
      }
      // 判断是否超出库存
      if (e.cartNum > e.Stock || e.Stock == 0) {
        this.$toast({
          position: 'bottom',
          message: '购买商品数量超过了该商品库存，库存余（' + e.Stock + '）'
        })
        e.cartNum = e.Stock
        return
      }
      // 基础验证通过,调用接口
      const res = await this.postAction('/api_order/ShoppingCarts/AddOrUpdateCart', {
        ProductSKUId: e.Id,
        Count: e.cartNum,
        IsAdd: true,
        SourceGoodsSkuId: e.SourceGoodsSkuId,
        IsPrice: false
      })
      if (res.IsSuccess) {
        this.$nextTick(() => {
          if (res.Data.CountData) {
            // 判断是否可以加购
            if (res.Data.IsLimitPerOrder) {
              this.$toast({
                position: 'bottom',
                message: '单笔订单限购（' + e.LimitPerOrder + '）' + e.Unit
              })
              return false
            }
            // 更新nav和右侧悬浮 购物车数量
            this.$bus.$emit('buycarChanged', res.Data.CountData.ProductCount, true)
            this.$bus.$emit('rightBuycarChanged', res.Data.CountData.ProductCount, true)
          }
          this.$toast({
            position: 'center',
            message: '添加购物车成功'
          })
        })
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .dialog-content {
    .dialog-head {
      position: relative;
      height: 45px;
      background: #F0EEEF;
      line-height: 45px;

      p {
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        color: #333333;
      }

      i {
        position: absolute;
        top: 14px;
        right: 15px;
        font-size: 18px;
        font-weight: 600;
        color: #5B5B5B;
        cursor: pointer;
      }
    }

    .dialog-body {
      padding: 40px;

      p {
        font-size: 13px;
        font-weight: 400;
        text-align: left;
        color: #3B4258;
        line-height: 150%;
      }
    }
  }

  .active {
    color: #0F6EE9 !important;
  }

  /deep/ .custom-dialog .el-dialog__header {
    padding: 0 !important;
  }

  /deep/ .custom-dialog .el-dialog__body {
    padding: 0 !important;
  }

  /deep/ .van-stepper__minus {
    border: 1px solid #C5CAD5;
    border-radius: 2px 0 0 2px;
    background: #FFFFFF;
  }

  /deep/ .van-stepper__input {
    margin: 0;
    border-top: 1px solid #C5CAD5;
    border-bottom: 1px solid #C5CAD5;
    background: #FFFFFF;
  }

  /deep/ .van-stepper__plus {
    border: 1px solid #C5CAD5;
    border-radius: 0 2px 2px 0;
    background: #FFFFFF;
  }

  /deep/ .custom-input input {
    width: 360px;
    color: #858B9C;
    background: #F0F3F5;
  }

  /deep/ .custom-input .el-input__prefix {
    display: flex;
    align-items: center;
    margin-left: 5px;
  }

  /deep/ .custom-btn {
    color: #0F6EEA !important;
  }

  /deep/ .custom-btn1 {
    color: #FFFFFF !important;
    background: #0F6EEA !important;
  }

  /deep/ .custom-btn-origin {
    margin-right: 14px;
    border: 1px solid #0F6EEA;
    color: #0F6EEA;
    background: rgba(15, 110, 234, .1);
  }

  /deep/ .el-button--primary.custom-btn-origin:focus,
  .el-button--primary.custom-btn-origin:hover {
    border: 1px solid #0F6EEA;
    color: #0F6EEA !important;
    background: rgba(15, 110, 234, .1) !important;
  }

  .ellips-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .search-pagination {
    //padding: 40px 0 40px 0;
  }

  .my-control-pin-box {
    position: relative;
    margin: 0 20px 0 0;
    border: 1px solid #E8E8E8;
    border-radius: 2px;
    padding: 20px 20px 0;
    width: 940px;
    font-size: 16px;
    background: #FFFFFF;
    box-sizing: border-box;

    .head-title {
      h4 {
        margin: 0;
        font-size: 18px;
        font-weight: 500;
        color: #222222;
      }

      p {
        margin: 0 16px;
        cursor: pointer;
      }

      span {
        margin-left: 5px;
        font-size: 12px;
        font-weight: 400;
        color: #0F6EEA;
      }
    }

    .line {
      margin: 10px 0;
      border: 1px solid #E8E8E8;
      width: 100%;
      height: 2px;
    }

    .detail {
      p {
        margin: 0 20px 0 0;
        font-size: 14px;
        font-weight: 400;
        color: #111A34;

        &.sort {
          i {
            font-size: 15px;
            font-weight: 600;
            color: #444444;
            cursor: pointer;
          }
        }
      }
    }

    .goods-list-box {
      position: relative;
      max-width: 1200px;
      flex-wrap: wrap;

      .goods-item {
        margin: 0 12px 16px 0;
        border: 1px solid #EDECEC;
        border-radius: 2px;
        //width: 227px;
        width: 215px;
        background: #FFFFFF;
        box-sizing: border-box;
        cursor: pointer;

        &:nth-child(4n) {
          margin-right: 0;
        }

        .pd-box {
          border-radius: 2px;
          padding: 8px;
          width: 100%;
          height: 100%;
          text-align: left;
          box-sizing: border-box;

          &:hover {
            .goods-pic {
              transform: scale(1.05);
            }
          }

          .goods-img-box {
            position: relative;
            overflow: hidden;
            width: 100%;
            height: 200px;
            background: #F3F5F8;

            .goods-img {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 200px;

              .goods-pic {
                width: 100%;
                height: 100%;
                transition: all .6s;
              }
            }

            .goods-class {
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1;
              border-radius: 8px 8px 0 0;
              padding: 0 10px;
              width: 100%;
              height: 28px;
              font-size: 12px;
              color: #FFFFFF;
              line-height: 28px;
              box-sizing: border-box;

              &.default {
                background: rgba(102, 111, 131, .5);
              }

              &.hint {
                background: #FF7575;
              }

              &.warning {
                background:
                  linear-gradient(
                    328deg,
                    #FF6831 0%,
                    #F3180E 100%
                  );
              }

              &.active {
                top: 0;
                width: 100%;

                img {
                  width: 100%;
                  height: 100%;
                }

                .rule_show {
                  position: absolute;
                  top: 0;
                  overflow: hidden;
                  padding-left: 30%;
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }

          .goods-info {
            .tag-box {
              display: flex;
              align-items: center;
            }

            .goods-name {
              font-size: 16px;
              font-weight: 600;
              color: #111A34;
            }

            .goods-msg-item {
              margin-top: 4px;
              font-size: 14px;
              font-weight: 500;
              color: #666F83;
              line-height: normal;
            }

            .goods-price {
              margin-top: 10px;

              .money {
                margin-right: 8px;
                font-size: 20px;
                font-family: Avenir-Heavy, Avenir;
                font-weight: 800;
                color: #FF3939;
              }
            }

            .goods-disc {
              margin-top: 4px;
              font-size: 12px;
              color: #666F83;
            }

            .goods-bottom {
              margin-top: 14px;

              .join-btn {
                border-color: #F60707;
                border-radius: 2px;
                padding: 0 8px;
                width: 72px;
                height: 28px;
                background: #F60707;
              }

              .join-btn-control {
                border-color: #0F6EEA;
                border-radius: 2px;
                padding: 0 8px;
                width: 72px;
                height: 28px;
                background: #0F6EEA;
              }

              .join-btn-ready {
                border-radius: 2px;
                padding: 0 8px;
                width: 72px;
                height: 28px;
              }
            }
          }
        }
      }
    }
  }
</style>
